import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SirenIcon = createIcon({
  displayName: 'SirenIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="11.99999"
        y1="2.94474"
        x2="11.99999"
        y2="2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="18.99999"
        y1="6"
        x2="19.94473"
        y2="5.05526"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="4.99999"
        y1="6"
        x2="4.05525"
        y2="5.05526"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="20.97499"
        y1="12"
        x2="21.91973"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="2.05525"
        y1="12"
        x2="2.99999"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6,17H18a2,2,0,0,1,2,2v.5A1.5,1.5,0,0,1,18.5,21H5.5A1.5,1.5,0,0,1,4,19.5V19A2,2,0,0,1,6,17Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.99999"
        y1="12"
        x2="13.99999"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="11.99999"
        y1="14"
        x2="11.99999"
        y2="10"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.5,17V11.5A5.5,5.5,0,0,0,12,6h0a5.5,5.5,0,0,0-5.5,5.5V17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const Siren: FC<IconProps> = (props) => {
  return <CustomIcon as={SirenIcon} {...props} />
}

export default memo(Siren)
